<kendo-switch
    size="small"
    [id]="controlName"
    [name]="controlName"
    [disabled]="disabled"
    [checked]="toggledOn"
    [ngModel]="toggledOn"
    (ngModelChange)="onToggle.emit($event)">
</kendo-switch>
